import React, {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {Tooltip} from "@material-tailwind/react";
import {useFindChartRating} from "../../../services/apis/apiDashboard";
import {Person} from "../../../services/interface/query/person";
import {CreditRatingInterface} from "../../../services/interface/query/dashboard/credit-rating-interface";
import NotPermissionComponent from "../NotPermissionComponent";
import {validEmptyText} from "../../../utils/textOptions";

interface Props {
    className?: string;
    sri?: boolean;
    person?: Person | null;
}

export default function Score({className, sri, person}: Props) {
    const {t} = useTranslation("global");
    const targetRef = useRef<HTMLDivElement>(null);

    const {
        mutate: findChartRating, isPending: loadingChartRating, error: errorChartRating, data: successChartRating
    } = useFindChartRating();

    const [value, setValue] = useState<string>()
    const [response, setResponse] = useState<CreditRatingInterface | undefined>()

    const find = () => {
        if (person && person.identification && !sri) {
            setResponse(undefined)
            findChartRating({identifier: person.identification, msj: t('criminal-record')})
        } else if (sri && person && person?.taxIdentificationNumber) {
            setResponse(undefined);
            findChartRating({identifier: person?.taxIdentificationNumber, msj: t('criminal-record')})
        }
    }

    useEffect(() => {
        find();
    }, [person]);

    useEffect(() => {
        if (successChartRating) {
            const aux: CreditRatingInterface = successChartRating
            aux.catalogAxisX = aux.catalogAxisX?.map((axis, index) => ({
                ...axis,
                style: getW(index)
            }))
            setResponse(aux);
            setValue(successChartRating?.valueAxisX)
        }
    }, [successChartRating]);

    useEffect(() => {
        if (targetRef.current && value) {
            const element = targetRef.current.querySelector(`[data-score="${value}"]`);
            if (element) {
                element.scrollIntoView({behavior: 'smooth', block: 'nearest'});
            }
        }
    }, [value]);

    function getW(index: number) {
        const aux = ((sri ? 170 : 88) - (index * (sri ? 10 : 2.5)));
        return `${aux}px`
    }

    return (
        <>
            <div className={'flex flex-col gap-2'}>
                <h3>{t('qualification')}</h3>
                <NotPermissionComponent
                    className={'min-h-[150px]'}
                    title={'/chart/credit_rating'}
                    loading={loadingChartRating || !person}
                    error={errorChartRating}
                    component={
                        <>
                            <div
                                className={`flex flex-row min-w-[200px] !border border-secondary rounded-[5px] py-2 pr-2`}>
                                {response && response.catalogAxisX &&
                                    <div
                                        className={`${validEmptyText(className)} grid grid-cols-1 min-w-[100px] pr-2 gap-2 overflow-y-auto max-h-[150px]`}
                                        ref={targetRef}>
                                        {response && response.catalogAxisX && response?.catalogAxisX?.map((item, index) => (
                                            <Tooltip key={`tooltip-${index}`}
                                                     className={"bg-header tooltip max-w-[200px] text-center"}
                                                     content={item.descriptionCatalog}>
                                                <div
                                                    key={index}
                                                    data-score={item.codeCatalog} // Añade este atributo para identificar el elemento
                                                    className={`pl-2 rounded-r-[10px] h-[20px] text-[12px] ${item.codeCatalog === value ?
                                                        '!border-header border-y-[2px] border-r-[2px]' :
                                                        'opacity-70'}`}
                                                    style={{background: item.color, width: item.style}}>
                                                    {item.codeCatalog}
                                                </div>
                                            </Tooltip>
                                        ))}
                                    </div>}
                                <div
                                    style={{background: response?.color}}
                                    className={`ml-auto flex flex-col text-center text-header rounded-[5px] max-h-[168px]`}
                                >
                                    <div className={'flex max-h-[105px] justify-center'}>
                                    <span
                                        className={`mt-[-20px] font-bold ${value && value.length > 1 ? 'text-[73px]' : 'text-[100px]'}`}>
                                        {value}
                                    </span>
                                    </div>
                                    <Tooltip className={"bg-header tooltip max-w-[200px] text-center"}
                                             content={response?.subtitle}>
                                        <span
                                            className={'text-[14px] px-[1px] overflow-y-auto mt-auto max-h-[70px]'}>{response?.subtitle}</span>
                                    </Tooltip>
                                </div>
                            </div>
                        </>
                    }
                />
            </div>
        </>
    )
}
